import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'register-confirm',
  templateUrl: './register-confirm.component.html',
  styleUrls: ['./register-confirm.component.css']
})
export class RegisterConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
